import { memo } from 'react';

import { Portal } from '@air/primitive-portal';

import { CopyToWorkspacePanel } from '~/components/CopyToWorkspace/CopyToWorkspacePanel';

export const PublicClipActivityContainer = memo(() => {
  return (
    <Portal>
      <div className="fixed right-4 bottom-6">
        <CopyToWorkspacePanel />
      </div>
    </Portal>
  );
});

PublicClipActivityContainer.displayName = 'PublicClipActivityContainer';
